import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useGetCouponbyIdQuery } from "../../Services/CouponsAPI";
import {  useParams } from "react-router-dom";


function AddCategory() {
    const { id } = useParams();
    const [code, setCode] = useState("")
    const [discount, setDiscount] = useState("");
    const [type, setType] = useState("percentage");
    const [validFrom, setValidFrom] = useState("");
    const [validUntil, setValidUntil] = useState("");
   

    const { data: categoryDetail, isLoading: loadingContent, error, refetch: refetchCategoryDetail } = useGetCouponbyIdQuery(id);


    useEffect(() => {
        refetchCategoryDetail();
    },[refetchCategoryDetail])

    useEffect(() => {
        console.log("categoryDetail", categoryDetail)
        setCode(categoryDetail?.data?.code);
        setDiscount(categoryDetail?.data?.discount);
        setType(categoryDetail?.data?.type);
        setValidFrom(categoryDetail?.data?.valid_from ? categoryDetail?.data?.valid_from.split(" ")[0] : "");
        setValidUntil(categoryDetail?.data?.valid_until ? categoryDetail?.data?.valid_until.split(" ")[0] : "");
    }, [categoryDetail])



    if (loadingContent) return <div class="loader"></div>;
    if (error) return <p>Failed to load Data</p>;

    return (
        <div>
            <h3>Coupon</h3>
            <div className="breadcrum mb-4">
                <p>
                    <Link to="/coupon-list"><span>Coupon</span></Link>
                    <FontAwesomeIcon icon={faAngleRight} className="mx-2" />
                    <span className="active-link">View</span>
                </p>
            </div>
            <div className="content-wrapper">
                <form>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="mb-4">
                                <label className="form-label">Coupon Code</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Coupon Code"
                                    value={code}
                                    onChange={(e) => setCode(e.target.value)}
                                />
                               
                            </div>
                        </div>

                        {/* Discount */}
                        <div className="col-md-6">
                            <div className="mb-4">
                                <label className="form-label">Discount</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Discount"
                                    value={discount}
                                    onChange={(e) => setDiscount(e.target.value)}
                                />
                               
                            </div>
                        </div>

                        {/* Type */}
                        <div className="col-md-6">
                            <div className="mb-4">
                                <label className="form-label">Type</label>
                                <select
                                    className="form-control"
                                    value={type}
                                    onChange={(e) => setType(e.target.value)}
                                >
                                    <option value="percentage">Percentage</option>
                                    <option value="fixed">Fixed</option>
                                </select>
                            </div>
                        </div>

                        {/* Valid From */}
                        <div className="col-md-6">
                            <div className="mb-4">
                                <label className="form-label">Valid From</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={validFrom}
                                    onChange={(e) => setValidFrom(e.target.value)}
                                />
                                
                            </div>
                        </div>

                        {/* Valid Until */}
                        <div className="col-md-6">
                            <div className="mb-4">
                                <label className="form-label">Valid Until</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={validUntil}
                                    onChange={(e) => setValidUntil(e.target.value)}
                                />
                              
                            </div>
                        </div>
                    </div>


                </form>
            </div>
        </div>
    );
}

export default AddCategory;
